/**
 * 创建 Agent — 使用真实 API
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAgent, CreateAgentRequest } from '../../api/agent';

const AGENT_TYPES = [
  { key: 'lifestyle', label: '生活助手', emoji: '🏠' },
  { key: 'development', label: '开发工具', emoji: '💻' },
  { key: 'office', label: '办公效率', emoji: '📋' },
  { key: 'creative', label: '创作灵感', emoji: '🎨' },
  { key: 'marketing', label: '营销增长', emoji: '📈' },
];

export default function NewAgentPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('lifestyle');
  const [systemPrompt, setSystemPrompt] = useState('');
  const [model, setModel] = useState('auto');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) return;
    setSubmitting(true);
    try {
      const data: CreateAgentRequest = {
        name: name.trim(),
        description: description.trim(),
        category,
        model,
        systemPrompt: systemPrompt.trim() || undefined,
      };
      const agent = await createAgent(data);
      navigate(`/simon-cat/agents/${agent.agentId}`);
    } catch (e) {
      alert('创建失败，请检查网络连接');
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate('/simon-cat')}>
          ← 返回
        </button>
        <h1 style={styles.title}>创建新 Agent</h1>
      </div>

      {/* Name */}
      <div style={styles.field}>
        <label style={styles.label}>名称 *</label>
        <input
          style={styles.input}
          placeholder="例如：智能客服助手"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      {/* Description */}
      <div style={styles.field}>
        <label style={styles.label}>描述</label>
        <input
          style={styles.input}
          placeholder="一句话说明这个 Agent 能做什么"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>

      {/* Type */}
      <div style={styles.field}>
        <label style={styles.label}>类型</label>
        <div style={styles.typeGrid}>
          {AGENT_TYPES.map((t) => (
            <button
              key={t.key}
              style={{ ...styles.typeBtn, ...(category === t.key ? styles.typeBtnActive : {}) }}
              onClick={() => setCategory(t.key)}
            >
              <span style={styles.typeEmoji}>{t.emoji}</span>
              <span>{t.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* System Prompt */}
      <div style={styles.field}>
        <label style={styles.label}>System Prompt</label>
        <textarea
          style={styles.textarea}
          placeholder="定义 Agent 的角色、能力和行为准则..."
          value={systemPrompt}
          onChange={(e) => setSystemPrompt(e.target.value)}
        />
      </div>

      {/* Submit */}
      <div style={styles.actions}>
        <button style={styles.cancelBtn} onClick={() => navigate('/simon-cat')}>
          取消
        </button>
        <button
          style={{ ...styles.submitBtn, opacity: submitting ? 0.6 : 1 }}
          onClick={handleSubmit}
          disabled={submitting || !name.trim()}
        >
          {submitting ? '创建中...' : '创建 Agent'}
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 600, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 18 },
  header: { display: 'flex', alignItems: 'center', gap: 12 },
  backBtn: {
    background: 'transparent', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 6, padding: '6px 10px', color: '#94a3b8', fontSize: 12, cursor: 'pointer',
  },
  title: { fontSize: 20, fontWeight: 700, margin: 0 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 12, fontWeight: 600, color: '#94a3b8' },
  input: {
    width: '100%', padding: '10px 14px', borderRadius: 8,
    border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)',
    color: '#e2e8f0', fontSize: 13, outline: 'none',
  },
  typeGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8 },
  typeBtn: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
    padding: '10px 6px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.06)',
    background: 'transparent', color: '#94a3b8', fontSize: 11, cursor: 'pointer',
  },
  typeBtnActive: { border: '1px solid #6366f1', background: 'rgba(99,102,241,0.1)', color: '#a5b4fc' },
  typeEmoji: { fontSize: 18 },
  textarea: {
    width: '100%', minHeight: 120, padding: '10px 14px', borderRadius: 8,
    border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)',
    color: '#e2e8f0', fontSize: 13, outline: 'none', resize: 'vertical' as const, fontFamily: 'inherit',
  },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
  cancelBtn: {
    padding: '8px 18px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)',
    background: 'transparent', color: '#94a3b8', fontSize: 12, cursor: 'pointer',
  },
  submitBtn: {
    padding: '8px 20px', borderRadius: 8, border: 'none',
    background: '#6366f1', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer',
  },
};
